import React from 'react';
import { Button, Menu, Tooltip } from '@mantine/core';
import { IconChevronDown, IconDownload } from '@tabler/icons-react';
import type { ButtonProps } from '@mantine/core';

type ExportCostOptionsButtonProps = {
    label: string;
    disabled?: boolean;
    loading?: boolean;
    tooltipLabel?: string;
    onExport: (includeCostPricesAndMargins: boolean) => void;
    hideCostAndMargins?: boolean;
    variant?: ButtonProps['variant'];
    size?: ButtonProps['size'];
    className?: string;
    radius?: ButtonProps['radius'];
    showDownloadIcon?: boolean;
};

export function ExportCostOptionsButton({
    label,
    disabled = false,
    loading = false,
    tooltipLabel,
    onExport,
    hideCostAndMargins = false,
    variant = 'outline',
    size = 'sm',
    className,
    radius,
    showDownloadIcon = true,
}: ExportCostOptionsButtonProps) {
    const exportButton = hideCostAndMargins ? (
        <Button
            variant={variant}
            size={size}
            radius={radius}
            disabled={disabled || loading}
            loading={loading}
            className={className}
            leftSection={
                showDownloadIcon ? <IconDownload size={16} /> : undefined
            }
            onClick={() => onExport(false)}
        >
            {label}
        </Button>
    ) : (
        <Menu withinPortal position="bottom-end">
            <Menu.Target>
                <Button
                    variant={variant}
                    size={size}
                    radius={radius}
                    disabled={disabled || loading}
                    loading={loading}
                    className={className}
                    leftSection={
                        showDownloadIcon ? (
                            <IconDownload size={16} />
                        ) : undefined
                    }
                    rightSection={<IconChevronDown size={16} />}
                >
                    {label}
                </Button>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item onClick={() => onExport(true)}>
                    Include cost prices and margins
                </Menu.Item>
                <Menu.Item onClick={() => onExport(false)}>
                    Excluding cost prices and margins
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );

    if (!tooltipLabel) {
        return exportButton;
    }

    return (
        <Tooltip label={tooltipLabel} openDelay={100}>
            <div className="shrink-0">{exportButton}</div>
        </Tooltip>
    );
}
